export default __webpack_public_path__ + "supplemental-context-example.736cdf19.png";